import React from 'react';

import { store } from '../app/store';
import { appRecord } from '../utils/appRecord';

import { setCurrentPage } from './paginationSlice';

const initialPage = appRecord && !isNaN(parseInt(appRecord.pagination.currentPage, 10)) ?
  parseInt(appRecord.pagination.currentPage, 10) : 1;

export default class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      pager: {}
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.items && this.props.items.length) {
      this.setPage(initialPage);
    }

    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.initialPage);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(event) {
    if (event.key === 'ArrowLeft') {
      this.setPage(this.state.pager.currentPage - 1)
    } else if (event.key === 'ArrowRight') {
      this.setPage(this.state.pager.currentPage + 1)
    }
  }

  setPage(page) {
    var items = this.props.items;
    var pager = this.state.pager;

    if (page < 1 || page > pager.totalPages) {
      return;
    }

    pager = this.getPager(items.length, page);

    var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

    this.setState({ pager: pager });

    this.props.onChangePage(pageOfItems);

    store.dispatch(setCurrentPage(page));
  }

  getPager(totalItems, currentPage, pageSize) {
    currentPage = currentPage || 1;

    // Количество элементов на каждой странице
    pageSize = pageSize || 1;

    var totalPages = Math.ceil(totalItems / pageSize);

    var startPage, endPage;

    var sidebarStartPage = 1;
    var sidebarEndPage = totalPages;
    
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } 
    else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } 
      else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } 
      else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);
    var sidebarPages = [...Array((sidebarEndPage + 1) - sidebarStartPage).keys()].map(i => sidebarStartPage + i);

    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      sidebarStartPage: sidebarStartPage,
      endPage: endPage,
      sidebarEndPage: sidebarEndPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
      sidebarPages: sidebarPages,
    };
  }

  render() {
    var pager = this.state.pager;

    if (!pager.pages || pager.pages.length <= 1) {
      return null;
    }

    return (
    <>
      <aside>  
        <ul className="Sidebar">
          {pager.sidebarPages.map((page, index) =>
            <li key={index}>
              <a className={pager.currentPage === page ? 'Active' : ''} 
                onClick={() => this.setPage(page)}
              >
                Страница {page}
              </a>
            </li>
          )}
        </ul>
      </aside>  
      <ul className="Navigation">
        <li title="Назад" className={`Link ${pager.currentPage === 1 ? 'Disabled' : ''}`}>
          <a
            className="Symbol"
            onClick={() => this.setPage(pager.currentPage - 1)}
            tabIndex="-1"
            onKeyDown={this.handleKeyDown}
          >
            –
          </a>
        </li>
        {pager.pages.map((page, index) =>
          <li key={index} className={`Link ${pager.currentPage === page ? 'Active' : ''}`}>
            <a onClick={() => this.setPage(page)}>{page}</a>
          </li>
        )}
        <li title="Вперед" className={`Link ${pager.currentPage === pager.totalPages ? 'Disabled' : ''}`}>
          <a
            className="Symbol"
            onClick={() => this.setPage(pager.currentPage + 1)}
            tabIndex="-1"
            onKeyDown={this.handleKeyDown}
          >
            +
          </a>
        </li>
      </ul>
    </>
    );
  }
}
